import React, { useState, useRef, useEffect } from "react";
import { FiUser, FiLogOut } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiSearch, FiBell, FiChevronDown, FiX } from "react-icons/fi";
import Logo from "../assets/home/logo.svg";
import Signup from "../pages/modals/Signup";
import Login from "../pages/modals/Login";

const Header = ({ testTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [userData, setUserData] = useState(null);

  const isExamInstructions = [
    "/exam-instructions",
    "/test-instructions",
  ].includes(location.pathname);

  const dashboardRoutes = [
    "/dashboard",
    "/previous-year-papers",
    "/practice",
    "/free-quizzes",
    "/subscription",
    "/profile",
  ];

  const isDashboard = dashboardRoutes.some((route) =>
    location.pathname.startsWith(route),
  );
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  // --- LocalStorage se User Data fetch karna ---
  useEffect(() => {
    const storedUser = localStorage.getItem("profile");
    if (storedUser) {
      try {
        setUserData(JSON.parse(storedUser).user);
      } catch (error) {
        console.error("Error parsing user data", error);
      }
    }
  }, [location.pathname]); // Route change hone par refresh check karega

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("profile");
    setUserData(null);
    setIsUserMenuOpen(false);
    navigate("/");
  };

  // Default Image Logic
  const defaultAvatar =
    "https://ui-avatars.com/api/?name=" +
    (userData?.name || "User") +
    "&background=6A10CB&color=fff";

  const isLoggedIn = !!userData;

  return (
    <header className="w-full h-20 bg-white shadow-[0_2px_4px_rgba(0,0,0,0.25)] flex items-center justify-center sticky top-0 z-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 lg:px-6 flex items-center justify-between">
        {isExamInstructions ? (
          <div className="flex items-center gap-4 w-full">
            <img
              src={Logo}
              alt="BaapBola Logo"
              className="object-contain w-[110px] sm:w-[130px] md:w-[150px] lg:w-[170px] h-auto"
            />
            <h1 className="text-[#333333] text-[16px] md:text-[20px] font-[500] whitespace-nowrap overflow-hidden text-ellipsis font-inter tracking-tight">
              {testTitle ||
                "SSC GD Constable: Dashboard Rakshak - Mini Live Test"}
            </h1>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2.5">
              <img
                src={Logo}
                alt="BaapBola Logo"
                className="object-contain w-[110px] sm:w-[130px] md:w-[150px] lg:w-[170px] h-auto"
              />
            </div>

            {isDashboard ? (
              <div className="flex items-center gap-6 flex-1 justify-end md:justify-between">
                {/* Desktop Search */}
                <div className="hidden md:flex flex-1 max-w-[500px] mx-8 relative">
                  <div className="relative w-full">
                    <input
                      type="text"
                      placeholder="Search for Courses, test..."
                      className="w-full h-[48px] pl-12 pr-4 rounded-full border border-[#E0E0E0] outline-none text-[#333] placeholder:text-[#33333399] text-[15px]"
                    />
                    <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-[#666] text-[20px]" />
                  </div>
                </div>

                <div className="flex items-center gap-4 md:gap-6">
                  {/* Mobile Search Icon */}
                  <button
                    onClick={() => setShowSearch(true)}
                    className="md:hidden text-[#333]"
                  >
                    <FiSearch className="text-[22px]" />
                  </button>

                  <button className="relative p-1">
                    <FiBell size={24} className="text-[#000]" />
                    <span className="absolute top-0 right-0 bg-red-600 text-white text-[10px] font-bold w-[16px] h-[16px] flex items-center justify-center rounded-full border border-white">
                      3
                    </span>
                  </button>

                  {/* USER PROFILE SECTION */}
                  <div ref={userMenuRef} className="relative">
                    <div
                      onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                      className={`flex items-center gap-3 md:border border-[#E0E0E0] rounded-[8px] md:p-[4px] md:pr-3 cursor-pointer transition-colors ${isUserMenuOpen ? "bg-gray-100" : "hover:bg-gray-50"}`}
                    >
                      <img
                        src={userData?.profileImage || defaultAvatar}
                        alt="User"
                        className="w-[38px] h-[38px] rounded-full object-cover border border-gray-200"
                      />
                      <div className="hidden md:flex flex-col leading-tight text-left">
                        <span className="text-[14px] font-bold text-[#333] capitalize">
                          {userData?.name || "Aarav Sharma"}
                        </span>
                        <span className="text-[11px] text-[#666] font-medium capitalize">
                          {userData?.subscription?.plan || "Free"} User
                        </span>
                      </div>
                      <FiChevronDown
                        className={`text-[#333] ml-1 hidden md:flex transition-transform duration-200 ${isUserMenuOpen ? "rotate-180" : ""}`}
                      />
                    </div>

                    {isUserMenuOpen && (
                      <div className="absolute right-0 mt-3 w-[220px] bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50 animate-in fade-in zoom-in-95 font-inter text-left">
                        <Link
                          to="/dashboard/profile"
                          className="w-full flex items-center gap-3 px-4 py-3 text-[14px] text-[#333] hover:bg-gray-50 transition-colors"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          <FiUser className="text-[18px]" /> My Profile
                        </Link>
                        {/* <Link
                          to="/dashboard/settings"
                          className="w-full flex items-center gap-3 px-4 py-3 text-sm text-[#333] hover:bg-gray-50 transition-colors"
                          onClick={() => setIsUserMenuOpen(false)}
                        >
                          <FiSettings className="text-[18px]" /> Settings
                        </Link> */}
                        <div className="h-px bg-gray-100 my-1" />
                        <button
                          onClick={handleLogout}
                          className="w-full flex items-center gap-3 px-4 py-3 text-[14px] text-red-600 hover:bg-red-50 transition-colors font-medium"
                        >
                          <FiLogOut className="text-[18px]" /> Logout
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <>
                <nav className="hidden md:flex items-center gap-10 lg:gap-12">
                  <a
                    href="/"
                    className="font-[500] text-[16px] lg:text-[18px] tracking-tight hover:text-brand-purple transition-colors text-[#000000]"
                  >
                    Home
                  </a>
                  <a
                    href="/"
                    className="font-[500] text-[16px] lg:text-[18px] tracking-tight hover:text-brand-purple transition-colors text-[#000000]">
                    About
                  </a>
                </nav>
                <div className="hidden md:flex items-center gap-4 lg:gap-5">
                  {isLoggedIn ? (
                    <button
                      onClick={() => navigate("/dashboard")}
                      className="px-7 h-11 rounded-xl
             bg-[#6A10CB] text-white
             text-[15px] lg:text-[16px] font-bold
             shadow-[0_8px_20px_rgba(106,16,203,0.35)]
             hover:scale-[1.03] hover:bg-[#5b0fc2]
             transition-all duration-200"
                    >
                      Dashboard
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => setShowLogin(true)}
                        className="w-[100px] lg:w-[102px] h-11 border border-[#6A10CB] rounded text-[#6A10CB] text-base lg:text-lg font-medium hover:bg-purple-50 transition-colors"
                      >
                        Login
                      </button>
                      <button
                        onClick={() => setShowSignup(true)}
                        className="w-[110px] lg:w-[119px] h-11 bg-gradient-to-r from-[#601DD1] to-[#256FFA] rounded text-white text-base lg:text-lg font-medium shadow-md hover:shadow-lg hover:brightness-105 transition-all"
                      >
                        Sign Up
                      </button>
                    </>
                  )}
                </div>
              </>
            )}

            {!isDashboard && (
              <button
                className="md:hidden z-50 text-2xl focus:outline-none"
                onClick={() => setIsOpen(!isOpen)}
              >
                {isOpen ? "✕" : "☰"}
              </button>
            )}
          </>
        )}



        <div
          className={`
    fixed top-0 right-0 h-full w-4/5 max-w-[320px] bg-white shadow-2xl
    transform transition-transform duration-300 ease-in-out md:hidden z-50
    ${isOpen ? "translate-x-0" : "translate-x-full"}
  `}
        >
          <div className="flex flex-col h-full p-6">

            {/* Top Section */}
            <div className="flex justify-between items-center mb-8">
              <img
                src={Logo}
                alt="Logo"
                className="w-[120px] object-contain"
              />
              <button
                onClick={() => setIsOpen(false)}
                className="text-2xl"
              >
                ✕
              </button>
            </div>

            {/* Navigation Links */}
            <nav className="flex flex-col gap-5 text-[16px] font-medium">
              <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
              <Link to="/" onClick={() => setIsOpen(false)}>About</Link>

              {isLoggedIn && (
                <Link to="/dashboard" onClick={() => setIsOpen(false)}>
                  Dashboard
                </Link>
              )}
            </nav>

            {/* Bottom Buttons */}
            {!isLoggedIn && (
              <div className="mt-auto flex flex-col gap-4">
                <button
                  onClick={() => {
                    setIsOpen(false);
                    setShowLogin(true);
                  }}
                  className="h-12 border border-[#6A10CB] rounded text-[#6A10CB]"
                >
                  Login
                </button>

                <button
                  onClick={() => {
                    setIsOpen(false);
                    setShowSignup(true);
                  }}
                  className="h-12 bg-[#6A10CB] text-white rounded"
                >
                  Sign Up
                </button>
              </div>
            )}
          </div>
        </div>
        {/* Search Modal (Same as your design) */}
        {showSearch && (
          <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-start justify-center pt-24 px-4">
            <div className="bg-white w-full max-lg rounded-xl shadow-2xl p-4 relative">
              <button
                onClick={() => setShowSearch(false)}
                className="absolute top-2 right-2 p-2 bg-gray-100 rounded-full text-gray-600"
              >
                <FiX size={20} />
              </button>
              <h3 className="text-sm font-semibold text-gray-500 mb-3 uppercase">
                Search
              </h3>
              <div className="relative w-full">
                <input
                  type="text"
                  autoFocus
                  placeholder="Search..."
                  className="w-full h-[50px] pl-12 pr-4 rounded-lg bg-gray-50 border border-gray-200 outline-none focus:ring-2 focus:ring-[#6A10CB]"
                />
                <FiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-[22px]" />
              </div>
            </div>
          </div>
        )}

        {/* Modals */}
        <Signup isOpen={showSignup} onClose={() => setShowSignup(false)} />
        <Login isOpen={showLogin} onClose={() => setShowLogin(false)} />
      </div>
    </header>
  );
};

export default Header;
